import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../common/form';

import * as models from '../../utils/models';

class HelideckDataAndGraphForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

	schema = {
		gridNo: Joi.string().required().label('Grid Number'),
		dimension: Joi.string().required().label('Dimension'),
		minimum: Joi.number().min(0).required().label('Minimum'),
		maximum: Joi.number().min(0).required().label('Maximum'),
		comments: Joi.string().required().label('Comments'),
	};

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'gridNo',
							label: 'Grid Number',
							placeholder: 'e.g. A1',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'dimension',
							label: 'Dimension',
							placeholder: 'e.g. 1.0 x 1.0',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'minimum',
							label: 'Minimum Coefficient',
							placeholder: 'e.g. 1',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'maximum',
							label: 'Maximum Coefficient',
							placeholder: 'e.g. 1',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'comments',
							label: 'Comment',
							placeholder: 'Select Comment',
							options: comments,
						})}
					</div>
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Add')}
				</div>
			</form>
		);
	}
}

const comments: models.SelectOption[] = [
	{ id: 'accept', name: 'Accept' },
	{ id: 'reject', name: 'Reject' },
];

const initialData: models.HelideckGraphItem = {
	gridNo: '',
	dimension: '',
	minimum: 0,
	maximum: 0,
	comments: '',
};

export default HelideckDataAndGraphForm;
